module.exports = {
      id: "ic-usd-500-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-usd-500-usage",
      toString: function () {
        return this.url;
      }
    }